module.exports = __webpack_public_path__ + "static/map-669ccba6aa2f9b29a10a1d702ca97c72.jpg";